import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { RequireAuth } from './auth/RequireAuth';
import { DashboardLayout } from './layouts/DashboardLayout';
import { DashboardHome } from './pages/DashboardHome';
import { LanguagesPage } from './pages/LanguagesPage';
import { SubantasPage } from './pages/SubantasPage';
import { TingantasPage } from './pages/TingantasPage';
import { UpasargasPage } from './pages/UpasargasPage';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import './App.css';

function HomeRedirect() {
  const { accessToken } = useAuth();
  return <Navigate to={accessToken ? '/dashboard' : '/login'} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<HomeRedirect />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route
            path="/dashboard"
            element={
              <RequireAuth>
                <DashboardLayout />
              </RequireAuth>
            }
          >
            <Route index element={<DashboardHome />} />
            <Route path="languages" element={<LanguagesPage />} />
            <Route path="upasargas" element={<UpasargasPage />} />
            <Route path="subantas" element={<SubantasPage />} />
            <Route path="tingantas" element={<TingantasPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
